import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  codigosPostales: null,
  isLoading: false,
};

const codigoPostalSelectorSlice = createSlice({
  name: "business/codigosPostales",
  initialState,
  reducers: {
    clearCodigosPostales: {
      prepare: () => ({ payload: {} }),
      reducer: () => initialState,
    },
    fetchCodigosPostalesInited: {
      prepare: (props) => ({ payload: { props } }),
      reducer: (state) => {
        state.isLoading = true;
        state.codigosPostales = null;
      },
    },
    fetchCodigosPostalesCompleted: {
      prepare: (provinciaId, localidad, codigosPostales) => ({
        payload: { provinciaId, localidad, codigosPostales },
      }),
      reducer: (state, action) => {
        const { provinciaId, localidad, codigosPostales } = action.payload;
        state.codigosPostales = {
          [`${provinciaId}/${localidad}`]: codigosPostales.map((item) => ({
            value: item,
            label: item,
          })),
        };
        state.isLoading = false;
      },
    },
    fetchCodigosPostalesFailed: {
      prepare: (error) => ({ payload: { error } }),
      reducer: () => initialState,
    },
  },
});

const {
  clearCodigosPostales,
  fetchCodigosPostalesInited,
  fetchCodigosPostalesCompleted,
  fetchCodigosPostalesFailed,
} = codigoPostalSelectorSlice.actions;

const fetchCodigosPostales = (provinciaId, localidad) => {
  return async (dispatch, getState, services) => {
    try {
      dispatch(fetchCodigosPostalesInited({ provinciaId, localidad }));
      const response = await services.api.getProvinciasCodigosPostales(
        provinciaId,
        localidad,
      );
      dispatch(fetchCodigosPostalesCompleted(provinciaId, localidad, response));
    } catch (error) {
      console.error(error);
      dispatch(fetchCodigosPostalesFailed(error));
    }
  };
};

export default codigoPostalSelectorSlice.reducer;
export {
  clearCodigosPostales,
  fetchCodigosPostalesInited,
  fetchCodigosPostalesCompleted,
  fetchCodigosPostalesFailed,
  fetchCodigosPostales,
};
